import "./style.scss";

import { CreateSwapRequestProvider } from "./context";
import CreateSwapRequestPage from "./CreateSwapRequestPage";

const Swap = () => {
  return (
    <CreateSwapRequestProvider>
      <CreateSwapRequestPage />
    </CreateSwapRequestProvider>
  );
};

export default Swap;
